export default __webpack_public_path__ + "static/media/0x20d3922b4a1a8560e1ac99fba4fade0c849e2142.3b1f9548.svg";